import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Container, Tabs, Tab, Form, Button, Alert, Spinner, Row, Col, Breadcrumb  } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import subBannerImg from '../assets/images/sub-banner-img.png';

const RegisterPage = () => {

    const { t } = useTranslation();
    
    // State for tabs and forms
    const [activeTab, setActiveTab] = useState('password');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);

    // State for UI feedback
    const [otpMessage, setOtpMessage] = useState('');
    
    const title="Register"; 
    const breadcrumb="Register";
    
    

    // State for all form fields
    const [formData, setFormData] = useState({
        nid: '',
        sevenHundredNumber: '',
        mobileNo: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    
    // State for UI feedback
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        // --- Validation Step ---
        if (formData.password !== formData.confirmPassword) {
            setError(t('register_error_password_mismatch'));
            return; // Stop the submission
        }

        setLoading(true);
        console.log("Submitting Registration Data:", formData);

        // Simulate an API call
        setTimeout(() => {
            alert('Registration Successful!');
            setLoading(false);
            // Optionally reset form here
            setFormData({ nid: '', sevenHundredNumber: '', mobileNo: '', email: '', password: '', confirmPassword: '' });
        }, 2000);
    };

    return (
        <section className="float-left w-100 sub-banner-con login-sub-banner position-relative main-box">
            <Container>
                <Row className="align-items-center">
                <Col lg={7} md={7}>
                    <div className="sub-banner-content-con">
                    <h1>{t(title)}</h1>
                    <p dangerouslySetInnerHTML={{ __html: t(`${breadcrumb}_subtitle`) }}></p>
                    <div className="breadcrumb-con d-inline-block">
                        <Breadcrumb>
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>{t('nav_home')}</Breadcrumb.Item>
                        <Breadcrumb.Item active>{t(breadcrumb)}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    </div>
                </Col>
                <Col lg={5} md={5}>
                    <div className="login-form-wrapper wow animate__animated animate__fadeInUp">
                        <h3 className="text-center mb-4">{t('register_form_title')}</h3>
                        {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" name="nid" placeholder={t('register_nid_placeholder')} value={formData.nid} onChange={handleChange} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" name="sevenHundredNumber" placeholder={t('register_700_placeholder')} value={formData.sevenHundredNumber} onChange={handleChange} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="tel" name="mobileNo" placeholder={t('register_mobile_placeholder')} value={formData.mobileNo} onChange={handleChange} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="email" name="email" placeholder={t('register_email_placeholder')} value={formData.email} onChange={handleChange} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="password" name="password" placeholder={t('register_password_placeholder')} value={formData.password} onChange={handleChange} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="password" name="confirmPassword" placeholder={t('register_confirm_password_placeholder')} value={formData.confirmPassword} onChange={handleChange} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="primary" type="submit" className="w-100 btn-lg text-uppercase mt-3" disabled={loading}>
                                {loading ? <Spinner as="span" animation="border" size="sm" /> : (
                                    <>
                                        {t('register_btn_text')} <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                                    </>
                                )}
                            </Button>
                        </Form>
                    </div>
                </Col>
                </Row>
            </Container>
        </section>
    );
};

export default RegisterPage;